module.exports = __webpack_public_path__ + "static/media/exchange-orange.a7d26c36.png";